import { DiToken, registerDiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import type { EnvBase } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ENV_BASE: DiToken<EnvBase> = new DiToken<EnvBase>('EnvBase');

export function registerEnvBase(envBase: EnvBase): void {
  registerDiToken(ENV_BASE, () => envBase);
}
